// Components==============
import React from 'react';
import './GridFiller.module.scss';
// =========================

export default function GridFiller({ noWidth }: { noWidth?: boolean }) {
  return <div styleName="wrapper" style={{ width: noWidth ? '0.1px' : ' ' }} />;
}
